import { Account } from '../../../../types';
import { defaultAccount } from '../../../../store/Accounts';
import { AccountSelectionForm } from '../../../Compounds/UserCreation';
import { DetailRow } from './DetailRow';

interface PrimaryAccountRowProps {
  accounts: Account[];
  selectedAccount: Account | undefined;
  onSelect: (account: Account | undefined) => void;
}

export const PrimaryAccountRow = ({ accounts, selectedAccount, onSelect }: PrimaryAccountRowProps) => (
  <DetailRow
    testId="detail-row-account"
    label="Primary Account">
    <div className="w-full">
      <AccountSelectionForm
        accounts={[defaultAccount, ...accounts]}
        selectedAccount={selectedAccount || defaultAccount}
        setSelectedAccount={onSelect}
        size="small"
      />
    </div>
  </DetailRow>
);
